import React from 'react';
import { Navigate } from 'react-router-dom';

import { appIdToClaimCheckDefinitionMap } from '@verantos-dev/core-constants';
import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';

import useAuth from './useAuth';

export const withAuth =
  <P extends object>(
    Component: React.ComponentType<P>,
    appId?: EvidencePlatformSidebarAppID
  ): React.FC<P> =>
  (props: P) => {
    const {
      user: { roles },
    } = useAuth();
    if (
      appId === undefined ||
      roles.map(({ roleId }) => roleId).includes(appIdToClaimCheckDefinitionMap[appId])
    ) {
      return <Component {...props} appId={appId} />;
    }

    return <Navigate to="/" />;
  };
